<template>
<div class="list-certificates">
    <div class=" container">
        <div class="row">
            <div class="col-12 col-md-12 col-lg-4 pb-4 pt-2">
                <select v-model="list.course" class="form-control search-shadow" @change="getCert($event.target.value)" required>
                    <option v-for="item in courses" :value="item.id" :key="item.id">{{item.name}}</option>
                </select>
            </div>
        </div>
        <div class="row">
            <table class="table table-hover w-100 shadow" style="overflow:scroll">
                <thead class="thead-dark">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Nombre</th>
                        <th scope="col">Apellido</th>
                        <th scope="col">Email</th>
                        <th scope="col">Curso</th>
                        <th scope="col">Estado</th>
                        <th scope="col">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="collection-item"
                        v-for="(cert, index) in certificates"
                        :key="cert.id">
                        <th scope="row">{{ index +1 }} </th>
                        <td>{{cert.name}}</td>
                        <td>{{cert.lastname}}</td>
                        <td>{{cert.email}}</td>
                        <td>{{cert.course}}</td>
                        <td v-if="cert.status == 1 && cert.sigUri"><span class="badge badge-success">Firmado</span></td>
                        <td v-else-if="cert.status == 2"><span class="badge badge-danger">Eliminado</span></td>
                        <td v-else><span class="badge badge-secondary">No validado</span></td>
                        <td class="row justify-content-around">
                            <div class="btn-group btn-group-toggle" data-toggle="buttons">
                                <span class="btn btn-outline-danger btn-sm" title="Borrar" alt="Borrar" @click="updateCertItem(cert.id, {'status':2})"><font-awesome-icon icon="trash" /></span>
                                <button :disabled="!(allowSign && currentUser.signatureUrl && !cert.sigUri && cert.status != 2)" title="Firmar" alt="Firmar" class="btn btn-outline-dark btn-sm" @click="signCertItem(cert.id)"><font-awesome-icon icon="file-signature" /></button>
                                <button :disabled="!(cert.status == 0 && !cert.sigUri)" @click="updateInfo(cert.id)" title="Editar" alt="Editar" class="btn btn-outline-dark btn-sm" target="_blank"><font-awesome-icon icon="edit" /></button>
                                <a v-bind:class="!(cert.status != 0 && cert.sigUri) ? 'disabled': ''" v-bind:href="cert.sigUri" title="Firma" alt="Firma" class="btn btn-outline-dark btn-sm" target="_blank"><font-awesome-icon icon="key" /></a>
                                <a v-bind:class="!(cert.status != 0 && cert.certUri && cert.sigUri) ? 'disabled': ''" v-bind:href="cert.certUri" title="Diploma" alt="Diploma" class="btn btn-outline-dark btn-sm" target="_blank"><font-awesome-icon icon="file-pdf" /></a>
                                <!-- <button :disabled="!(cert.status != 0 && cert.sigUri)" v-bind:href="cert.certUri" title="Diploma" alt="Reenviar correo" class="btn btn-outline-dark btn-sm" target="_blank"><font-awesome-icon icon="envelope" /></button>-->
                                <router-link v-if="cert.status != 2" :to="{ name: 'Verify', params: {id: cert.id+'.'+list.course } }" title="Ver" alt="Ver" class="btn btn-outline-dark btn-sm" target="_blank"><font-awesome-icon icon="eye" /></router-link>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="row">
          <vue-html2pdf
            :show-layout="false"
            :float-layout="true"
            :enable-download="false"
            :preview-modal="true"
            :paginate-elements-by-height="2800"
            filename="Diploma digital"
            :pdf-quality="2"
            :manual-pagination="true"
            pdf-format="letter"
            pdf-orientation="landscape"
            pdf-content-width="100%"
            @beforeDownload="beforeDownload($event)"
            @progress="onProgress($event)"
            ref="html2Pdf">
            <section slot="pdf-content">
              <DefaultTemplate v-if="certData.template == 'default' || certData.template == undefined" v-bind:name="certData.name" v-bind:lastname="certData.lastname" v-bind:course="certData.course" v-bind:signDate="signDate" v-bind:verifyUrl="this.verifyUrl" v-bind:effort="certData.effort"/>
              <Mype v-if="certData.template == 1" v-bind:name="certData.name" v-bind:lastname="certData.lastname" v-bind:course="certData.course" v-bind:signDate="signDate" v-bind:verifyUrl="this.verifyUrl" v-bind:effort="certData.effort"/>
              <Profxxi v-if="certData.template == 2" v-bind:name="certData.name" v-bind:lastname="certData.lastname" v-bind:course="certData.course" v-bind:signDate="signDate" v-bind:verifyUrl="this.verifyUrl" v-bind:effort="certData.effort"/>
              <GES v-if="certData.template == 3" v-bind:name="certData.name" v-bind:lastname="certData.lastname" v-bind:course="certData.course" v-bind:signDate="signDate" v-bind:verifyUrl="this.verifyUrl" v-bind:effort="certData.effort"/>
            </section>
          </vue-html2pdf>
        </div>
    </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import firebase from "firebase/app"
import 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import PdfTemplateCreate from "@/components/CreatePdf.vue"
import VueHtml2pdf from 'vue-html2pdf'
const openpgp = require("openpgp")
import DefaultTemplate from "../templates/DefaultTemplate.vue"
import Mype from "../templates/Mype.vue"
import Profxxi from "../templates/Profxxi.vue"
import GES from "../templates/GES.vue"

export default {
    data() {
      return {
        list: {
          course: '',
          user: ''
        },
        colId: '',
        createPDF: false,
        triggerPrint: false,
        allowSign: false,
        certData: {},
        signDate: "",
        verifyUrl: "",
      };
    },
    created() {
        this.getCourses()
    },
    computed: {
        ...mapGetters({
            currentUser: 'currentUser',
            courses: 'activeCourses',
            certificates: 'currentCertificates',
            certificateData: 'pdfCertificate',
            certificateSaved: 'getCertificateSaved'
        })
    },
    watch: {
        certificateSaved: function (newVal) {
            let parsedobj = JSON.parse(JSON.stringify(newVal))
            if (parsedobj.courseId) {
                this.list.course = parsedobj.courseId
            }
        }
    },
    methods: {
        async getCert(courseId) {
          try {
            this.validateUser()
            await this.$store.dispatch('getActiveCourse', courseId)
            await this.$store.dispatch('getCertificatesCourse', courseId)
          } catch (error) {
            console.log('Error al obtener certificados')
          }
        },
        async getCourses() {
          try {
            await this.$store.dispatch('getCourses')
            this.list.course = this.courses[0].id
            if (this.list.course){
              this.validateUser()
              this.getCert(this.list.course)
            }
          } catch (error) {
            console.log('Error al obtener cursos')
          }
        },
        async getKeys() {
            let currentKeys = {}
            let configRef = await firebase.firestore().collection("config").doc('general2020')
            let doc = await configRef.get()

            if (doc.data().privateKey && doc.data().publicKey) {
                currentKeys.privateKey = doc.data().privateKey
                currentKeys.publicKey = doc.data().publicKey
            } else {
                currentKeys.privateKey = ""
                currentKeys.publicKey = ""
            }

            return currentKeys
        },
        deleteCert(docId) {
            firebase
                .firestore()
                .collection("entities")
                .doc(this.list.course)
                .collection("certificates")
                .doc(docId)
                .delete();
        },
        updateCertItem(docId, item) {
            firebase
                .firestore()
                .collection("entities")
                .doc(this.list.course)
                .collection("certificates")
                .doc(docId)
                .update(item);
        },
        async updateInfo(docId){
          try {
            let courseEffort = this.courses.find( (couse) => couse.id === this.list.course )

            let search = {
                course: this.list.course,
                certificate: docId,
                effort: courseEffort.effort,
                template : courseEffort.template
            }
            await this.$store.dispatch('getCertificate', search)
            //await this.$store.dispatch('getCertificate', course)
          } catch (error) {
            console.log('Error al obtener cursos')
          }
          this.$store.dispatch("toggleUserActionTrigger")
          this.$store.commit("setUserAction", "edit")
          this.$store.dispatch("toggleModalAddCertificate")
        },
        async searchManager(managers) {
          if (managers) {
            return managers.includes(firebase.auth().currentUser.uid)
          } else {
            return false
          }
        },
        async validateUser() {
            let courseInfo = await this.$store.getters.getCourseInfo(this.list.course)
            if (courseInfo) {
                this.allowSign = await this.searchManager(courseInfo.managers)
            }
        },
        //Metodos para firmar diploma
        async beforeDownload ({ html2pdf, options, pdfContent }) {
          options.html2canvas.allowTaint = true
          options.html2canvas.useCORS = true
          options.html2canvas.scrollX = 0
          options.html2canvas.scrollY = 0
          options.html2canvas.height = 815
          options.html2canvas.logging = false;
          if (this.certData.template === "2" || this.certData.template === "3") {
            options.image.quality = "1"
            options.html2canvas.scale = 5
            options.html2canvas.height = 816
          }
          let storageRef = firebase.storage().ref('certificates').child(`${this.certData.name}-${this.certData.lastname}-${this.certData.id}.pdf`);
          let certString = await html2pdf().from(pdfContent).set(options).toPdf().output('datauristring');
          let certDoc = await storageRef.putString(certString, 'data_url');
          let certDownloadUrl = await certDoc.ref.getDownloadURL();
          let data = { "certUri": certDownloadUrl, "status": 1 };
          pdfContent = undefined;
          options = "";

          await this.generateSign(certString, data);
          return true;
        },
        async generateSign(certFile, dataI) {
          let storageSigRef = firebase.storage().ref('signatures').child(this.certData.id+'.sig');
          const userKeys = await this.getKeys()
          const publicKeyArmored = userKeys.publicKey
          const privateKeyArmored = userKeys.privateKey

          const { data: encrypted } = await openpgp.encrypt({
              message: openpgp.message.fromText(certFile),
              publicKeys: (await openpgp.key.readArmored(publicKeyArmored)).keys
          })
          let sigDoc = await storageSigRef.putString(encrypted)
          let sigDownloadUrl = await sigDoc.ref.getDownloadURL()
          let data = {"sigUri": sigDownloadUrl, ...dataI}
          this.updateCertItem(this.certData.id, data)
          await this.sendEmail(this.certData.id, this.list.course);
          return true;
        },
        onProgress(event) {
          console.log(`Processed: ${event} / 100`);
        },
        async signCertItem(certId) {
          this.$toasted.show(`Se inicia a generar el PDF`)
          this.createPDF = true;
          this.list.user = certId;
          this.triggerPrint = !this.triggerPrint;
          this.certData = await this.getInfoCert(this.list.course, certId);
          this.setTimeAndUrl()
          await this.$refs.html2Pdf.generatePdf();
        },
        async getInfoCert(course, user) {
          const values = new Promise (async function (resolve) {
            //get Info course
            const courseRef = firebase.firestore().collection("courses").doc(course);
            const docCourse = await courseRef.get();
            const dataCourse = docCourse.data();

            //get info certificate
            const refCertificate = firebase.firestore().collection("entities").doc(course).collection("certificates").doc(user);
            let doc = await refCertificate.get();
            let cert = doc.data();
            resolve({ id: user, courseId: course, ...cert, effort: dataCourse.effort, template: dataCourse.template });
          });
          const infos = await values;
          return infos;
        },
        setTimeAndUrl() {
          //Set url
          this.verifyUrl = "https://"+window.location.hostname+'/verify/'+this.certData.id+'.'+this.certData.courseId

          //set time
          let dateVar = new Date(this.certData.issued.seconds * 1000)
          let months = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic']
          let months2 = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre']
          let year = dateVar.getFullYear()
          let month = months[dateVar.getMonth()]
          let date = dateVar.getDate()
          this.signDate = date + ' ' + month + ' ' + year
          if (this.certData.template === "2") {
            month = months2[dateVar.getMonth()]
            this.signDate = date + ' de ' + month + ' ' + year
          }
        },
        async sendEmail(userId, courseId, tried = 1 ){
          if (tried <= 3) {
            let statusSend = await this.$store.getters.sendEmail(userId, courseId);
            if (statusSend == 1) {
              this.$toasted.show(`Diploma enviado correctamente`)
            } else {
            //Intentar enviar 3 veces
              this.$toasted.show(`Error al enviar, intento ${tried}/3`, {type: "info"})
              this.sendEmail(userId, courseId, (tried + 1));
            }
          }
          this.verifyUrl = ""
          return true;
        }
    },
    components: {
        PdfTemplateCreate,
        VueHtml2pdf,
        DefaultTemplate,
        Mype,
        Profxxi,
        GES
    }
}

</script>

<style scoped>
.actions-cert {
    cursor: pointer;
}
.search-shadow {
    background: #fff;
    -webkit-box-shadow: 0px 8px 20px rgba(0,0,0,0.06);
    box-shadow: 0px 8px 20px rgba(0,0,0,0.06);
    border-radius: 8px;
    height: 44px;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    position: relative;
}
.shadow {
    background: #fff;
    -webkit-box-shadow: 0px 8px 20px rgba(0,0,0,0.06);
    box-shadow: 0px 8px 20px rgba(0,0,0,0.06);
    border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/ListCert.vue